<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow">
      <template v-slot:header></template>
      <template v-slot:title>
        <div class="d-flex ma-1 no-wrap" v-if="getAccess('contract.wizard.view')">
          <v-btn-toggle v-model="typeView" mandatory borderless dense class="mr-2">
            <v-btn :value="1" color="#d0bf9c">
              <span class="hidden-sm-and-down">Договоры</span>
              <v-icon :right="$vuetify.breakpoint.lgAndUp"> fas fa-file-signature </v-icon>
            </v-btn>
            <v-btn :value="2" class="ml-1" color="#d0bf9c">
              <span class="hidden-sm-and-down">Проекты</span>
              <v-icon :right="$vuetify.breakpoint.lgAndUp"> fas fa-cogs </v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>
      </template>
      <template v-slot:actions>
        <a-btn-refresh @click="onRefresh" />
        <a-btn-add :icon="'far fa-plus-square'" :title="'Создать'" v-if="getAccess('contract.create')" @click="createNew()" />
      </template>
      <portal to="v-main">
        <s-document-head v-model="showEditDialog" v-if="showEditDialog && typeView == 1" :api="url" :m="m" :config="configHead" :title="m.title" :id="idEdit" />
      </portal>
      <a-table-f-api
        v-if="typeView == 1"
        ref="table"
        :api="url"
        :model="model"
        :useQuery="false"
        :defaults="defaults"
        :selectedRows="selectedRows"
        @click="
          counter += 1;
          onDetectClick($event);
        "
        :setFilter="setFilter"
        @click1="onClickRow($event)"
      />
      <a-table-f-api
        v-if="typeView == 2"
        ref="table"
        :api="url + '/wizard'"
        :model="model"
        :useQuery="false"
        :defaults="defaults"
        :selectedRows="selectedRows"
        @click="
          counter += 1;
          onDetectClick($event);
        "
        @click1="onClickRow($event)"
      />
    </static-fullscreen-card>
    <ViewItem v-if="idItemShow && typeView == 1" :idShow="idItemShow" @close="itemShowClose($event)" />
    <Wizard v-if="showEditDialog && typeView == 2" :value="showEditDialog" @close="showEditDialog = !true" :id="idEdit" />
  </div>
</template>

<script>
import { getAccess, genModel, doubleClickDetect, keyDetect } from "@/components/mixings";

export default {
  mixins: [getAccess, genModel, doubleClickDetect, keyDetect],
  components: {
    ViewItem: () => import("./views/contractView"),
    Wizard: () => import("./wizard/contract/index"),
  },
  data() {
    return {
      typeView: 1,
      idEdit: 0,
      showEditDialog: false,
      idItemShow: 0,
      title: "",
      m: this.$store.getters["config/get"].models.contracts,

      url: "/accounting/dir/contract",
      defaults__: {
        sort: { key: "id", order: "DESC" },
        filters: { createdby_id: this.getAccess("contract.viewAll") ? null : this.$root.profile.id, parent_id: { condition: "IS", value: null } },
        paramName: "contract",
      },
      infoData: null,
      infoModel: null,
    };
  },
  created() {
    this.$root.title = this?.m?.title || "Журнал договоров";
  },
  computed: {
    defaults() {
      let filters = { parent_id: { condition: "IS", value: null } };
      if (this.$root.profile.role === 10) {
        const clients = (this.$root.profile?.clients || []).map((c) => {
          return c.id;
        });
        //filters.side_2_client_id = clients;
        //filters = {};
      } else {
        // filters = this.getAccess("contract.viewAll") ? {} : { createdby_id: this.$root.profile.id };
        // filters.createdby_id = this.getAccess("contract.viewAll") ? null : this.$root.profile.id;
      }

      let res = {
        sort: { key: "id", order: "DESC" },
        filters,
        paramName: "contract",
      };
      return res;
    },
    model() {
      let model = this.typeView == 2 ? this.getModelList(this.m.wizard) : this.getModelList(this.m);
      let r = model.find((m) => m.name == "createdby_id");
      if (r) r["searchable"] = this.getAccess("contract.viewAll");
      return model;
    },
    configHead() {
      return this.m.config.default || {};
    },
    permit() {
      return this.getAccess("menu.contract");
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.onRefresh();
      }
    },
  },
  methods: {
    onRefresh() {
      if (this.typeView == 1) this.$refs.table.updateData();
      if (this.typeView == 2) this.$refs.table.updateData();
    },
    setFilter(f) {
      delete f.side_2_vendor_id;
      delete f.side_2_client_id;
      delete f.side_2_investor_id;
      delete f.side_2_employer_id;
      delete f.or;
      if (f?.side_2_type) {
        const s = f.side_2_type;
        delete f.side_2_type;

        switch (s) {
          case "1":
            console.log("set vendor");
            f.side_2_vendor_id = { condition: "IS not", value: null };
            break;
          case "2":
            f["side_2_client_id"] = { condition: "IS not", value: null };
            break;
          case "3":
            f["side_2_investor_id"] = { condition: "IS not", value: null };
            break;
          case "4":
            f["side_2_employer_id"] = { condition: "IS not", value: null };
            break;

          default:
            break;
        }
      }
      if (f?.side_2_name) {
        const s = f.side_2_name.value;
        delete f.side_2_name;
        f["OR"] = [
          { "side_2_vendor.name": { condition: "LIKE", value: s } },
          { "side_2_client.name": { condition: "LIKE", value: s } },

          { "side_2_investor.name": { condition: "LIKE", value: s } },
          { "side_2_employer.name": { condition: "LIKE", value: s } },
        ];
      }
      return f;
    },
    itemShowClose() {
      this.loading = true;
      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },

    onSingleClick(d) {},
    onDoubleClick(d) {
      if (this.typeView == 2) {
        this.showEditDialogFun(d.row.id);
        return;
      }
      this.idItemShow = d.row.id;
      return;
      this.onClickRow(d);
    },
    onClickRow(d) {
      //  this.$router.push({ name: "objectBuy_view", params: { id: d.row.id } });

      this.showEditDialogFun(d.row.id);
    },
    itemShowClose() {
      this.loading = true;

      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },
  },
};
</script>
